import { api } from './customers'
export interface Treatment {
    id: number
    treatment_type_name: string
    active_status: number
}

export interface DashboardCount {
        merchant_user_count: number
        merchant_hospital_count: number
}
export interface Treatmentmaster {
    data:any
 
 }

type TreatmentResponse = Treatment[]

export const TreatmentApi = api.injectEndpoints({
    endpoints: (build) => ({
        getTreatments: build.query<TreatmentResponse, any>({
            query: () => 'treatment_type_master/',
            transformResponse: (response: { data: TreatmentResponse }, meta, arg) => response.data,
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({ type: 'Treatment' as const, id })),
                        { type: 'Treatment', id: 'LIST' },
                    ]
                    : [{ type: 'Treatment', id: 'LIST' }],
        }),
        getTreatmentsMaster: build.query<Treatmentmaster, any>({
            query: ({ pageNo, name }) => `treatment_type_master_page?page=${pageNo}&filter=${name}`,
            // transformResponse: (response: { data: TreatmentResponse }, meta, arg) => response.data,
            // providesTags: (result) =>
            //     result
            //         ? [
            //             ...result.map(({ id }) => ({ type: 'Treatment' as const, id })),
            //             { type: 'Treatment', id: 'LIST' },
            //         ]
            //         : [{ type: 'Treatment', id: 'LIST' }],
        }),
        addTreatments: build.mutation<Treatment, Partial<Treatment>>({
            query: (body) => ({
                url: `treatment_type_master/`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: Treatment }, meta, arg) => response.data,
            invalidatesTags: [{ type: 'Treatment', id: 'LIST' }],
        }),
        getTreatment: build.query<Treatment, string>({
            query: (id) => `treatment_type_master/${id}`,
            transformResponse: (response: { data: Treatment }, meta, arg) => response.data,
            providesTags: (result, error, id) => [{ type: 'Treatment', id }],
        }),
        updateTreatment: build.mutation<void, Pick<Treatment, 'id'> & Partial<Treatment>>({
            query: ({ id, ...patch }) => ({
                url: `treatment_type_master/${id}`,
                method: 'PUT',
                body: patch,

            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Treatment', id },{ type: 'Treatment', id:"LIST" }],
        }),
        deleteTreatment: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `treatment_type_master/${id}`,
                    method: 'DELETE',
                    body:{activeStatus:2}
                }
            },
            invalidatesTags: (result, error, id) => [{ type: 'Treatment', id }, { type: 'Treatment', id: 'LIST' }],
        }),
        getDashboardCount: build.query<DashboardCount, void>({
            query: () => `dashboard_count`,
            transformResponse: (response: { data: DashboardCount }, meta, arg) => response.data,
        }),
    }),
})



export const {
    useGetTreatmentsQuery,
    useGetTreatmentQuery,
    useGetTreatmentsMasterQuery,
    useAddTreatmentsMutation,
    useUpdateTreatmentMutation,
    useDeleteTreatmentMutation,
    useGetDashboardCountQuery
} = TreatmentApi

